import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import head from 'lodash/head'
import { cartSlice } from '@/store/cartSlice'
import { servicesSlice } from '@/store/servicesSlice'
import { timeScheduleSlice } from '..'
import { serviceAmountSelector } from './serviceAmountSelector'

export const groupAvailabilitySelector = createSelector(
  [
    timeScheduleSlice.selectors.service,
    servicesSlice.selectors.services,
    cartSlice.selectors.cartReservations,
    serviceAmountSelector,
  ],
  (service, apiServices, reservations, serviceAmount): number => {
    const ticketReservation = head(reservations)

    if (!service || !isSuccess(apiServices) || !ticketReservation) {
      return serviceAmount
    }

    const group = apiServices.value.serviceGroups.find(
      (g) => g.serviceGroupId === service.serviceGroupId
    )

    if (!group) {
      return serviceAmount
    }

    // skip the selected service, because it's current qty is the `serviceAmount`
    const filteredServices = group.services.filter(
      (s) => s.serviceId !== service.serviceId
    )

    const totalGroupBoughtQuantity =
      filteredServices.reduce<number>((acc, service) => {
        const bought = ticketReservation.boughtServices[service.serviceId]
        if (!bought) {
          return acc
        }
        return Object.values(bought).reduce((acc, b) => acc + b.bought, 0)
      }, 0) + serviceAmount

    const availableOnGroup = Math.max(
      0,
      Math.min(
        group.availableQuantity - totalGroupBoughtQuantity,
        (group.maximumQuantity > 0 ? group.maximumQuantity : Infinity) -
          group.reservedQuantity -
          totalGroupBoughtQuantity
      )
    )

    return availableOnGroup
  }
)
